module.exports = __webpack_public_path__ + "img/headerr.b5b1e4f9.png";